import { hmapPathParamConfig, hmapPathParamRegex } from "@ngmodules/hmap/hmap.routes";
export const InterviewInviteRoutes = [
    {
        "url": `/interview-invite/${hmapPathParamRegex}`,
        "name": "appLayout.harriSH.access-portal.settings.interview-invite",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            ...hmapPathParamConfig
        },
        "component": "interviewInviteContainer",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview-invite"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/interview-invite/interview-invite.downgrade.module");
                }
            },
        ]
    },
    {
        "url": `/interview-invite/create/${hmapPathParamRegex}?template_id`,
        "name": "appLayout.harriSH.access-portal.settings.create-interview-invite",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            ...hmapPathParamConfig
        },
        "component": "manageInterviewInviteContainer",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview-invite"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/interview-invite/interview-invite.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/interview-invite",
        "name": "appLayout.harriSH.interview-invite",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {},
        "component": "interviewInviteContainer",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview-invite"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/interview-invite/interview-invite.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/interview-invite/create?template_id",
        "name": "appLayout.harriSH.create-interview-invite",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {},
        "component": "manageInterviewInviteContainer",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview-invite"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/interview-invite/interview-invite.downgrade.module");
                }
            },
        ]
    }
];
//# sourceMappingURL=interview-invite.routes.js.map